import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {PartnerSummaryModel} from '../../../../partner/common/api/model/partnerSummary.model';
import {Moment} from 'moment';
import {FormDefinitionFormSummaryModel} from '../../../definition/form/api/entity/formDefinitionFormSummary.model';
import {DocumentSummaryModel} from '../../../../document/common/api/model/documentSummary.model';

export class FormSummaryModel implements SummaryModel {
    permissions: PermissionsModel;
    id: number;
    status: LovValueSummary;
    deadline: Moment;
    partner: PartnerSummaryModel;
    date: Moment;
    completionDate: Moment;
    formDefinition: FormDefinitionFormSummaryModel;
    comment: string;
    documents: DocumentSummaryModel[] = [];
}

export enum FormStatus {
    FORM_STATUS_TODO = 'FORM_STATUS_TODO',
    FORM_STATUS_IN_PROGRESS = 'FORM_STATUS_IN_PROGRESS',
    FORM_STATUS_COMPLETED = 'FORM_STATUS_COMPLETED',
    FORM_STATUS_REVIEWED = 'FORM_STATUS_REVIEWED'
}

export enum FormPermission {
    PERMISSION_ADD_DOCUMENT = 'FORM_PERMISSION_ADD_DOCUMENT',
    PERMISSION_PRINT = 'FORM_PERMISSION_PRINT'
}
